import { PortalDesignImage } from '../../types/settings/portal-settings'
import { getThumbnailUrl } from '../getFileUrl'

export const getCoverImageUrl = (
  contentImageId?: string | null,
  customThumbnailId?: string | null,
  defaultImage?: string
) => {
  if (contentImageId) return getThumbnailUrl(contentImageId, 900)
  if (customThumbnailId) return getThumbnailUrl(customThumbnailId, 900)

  return defaultImage ? defaultImage : ''
}

export const getCoverImageId = (
  contentImageId: number | null,
  isLessonType: boolean,
  portalDesignImages?: PortalDesignImage
) => {
  if (contentImageId) return contentImageId
  if (isLessonType && portalDesignImages?.default_cover_lessons) return portalDesignImages.default_cover_lessons
  if (portalDesignImages?.default_cover_quizzes) return portalDesignImages.default_cover_quizzes
}
